import { FC } from 'react';

import { Paper } from '@mui/material';

import { Loader } from 'components/_basic/Loader/Loader';

import styles from './WorkspaceLoader.module.scss';

export const WorkspaceLoader: FC = () => {
  return (
    <Paper elevation={0} className={styles.wrapper}>
      <Loader />
    </Paper>
  );
};
